import { wordScore, wordsOf } from "../shared/find";

/**
 * Moving through a story: to a turn (with a flash, and the words searched for marked), and back to where the reader
 * was before the jump (the "back to turn N" chip listens for weftwake:jumped). Themes mark each turn with data-turn.
 */

export const turnEls = () => [...document.querySelectorAll<HTMLElement>("[data-turn]")];

/** The turn at the top of the reading area now. */
export function topTurn(): number | null {
  const els = turnEls();
  if (!els.length) return null;
  let a = Number(els[0]!.dataset.turn);
  for (const el of els) if (el.getBoundingClientRect().top <= 96) a = Number(el.dataset.turn);
  return a;
}

let clearHighlight: number | undefined;
/** Marks the query's words in turn `n` (CSS highlights: the story's text is left untouched), for a few seconds. */
function highlight(n: number, terms: string[]) {
  const reg = (globalThis.CSS as { highlights?: Map<string, unknown> } | undefined)?.highlights;
  if (!reg || typeof Highlight === "undefined" || !terms.length) return;
  const els = turnEls();
  const i = els.findIndex((el) => Number(el.dataset.turn) === n);
  if (i < 0) return;
  const start = els[i]!, end = els[i + 1] ?? null;
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  walker.currentNode = start;
  const ranges: Range[] = [];
  for (let node = walker.currentNode.nodeType === Node.TEXT_NODE ? walker.currentNode : walker.nextNode(); node; node = walker.nextNode()) {
    if (end && (end === node || end.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING)) break;
    const text = node.textContent ?? "";
    for (const w of wordsOf(text)) {
      if (!terms.some((t) => wordScore(w.w, t) > 0)) continue;
      const r = document.createRange();
      r.setStart(node, w.at); r.setEnd(node, w.end);
      ranges.push(r);
    }
  }
  reg.set("lm-find", new Highlight(...ranges));
  window.clearTimeout(clearHighlight);
  clearHighlight = window.setTimeout(() => reg.delete("lm-find"), 8000);
}

/** Brings turn `n` (or the next turn that is on the page) to the top of the reading area. */
export function goToTurn(n: number, o: { smooth?: boolean; terms?: string[]; mark?: boolean } = {}) {
  const el = turnEls().find((e) => Number(e.dataset.turn) >= n);
  if (!el) return;
  // Remember where the reader was, so they can go back (a jump of a few turns isn't worth a chip).
  const from = topTurn();
  if (o.mark !== false && from !== null && Math.abs(from - n) > 2) window.dispatchEvent(new CustomEvent("weftwake:jumped", { detail: { from, to: n } }));
  const smooth = o.smooth !== false && !matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ block: "start", behavior: smooth ? "smooth" : "auto" });
  el.classList.remove("lm-flash");
  void el.offsetWidth;
  el.classList.add("lm-flash");
  if (o.terms?.length) highlight(Number(el.dataset.turn), o.terms);
}

